import React, { useEffect, useRef, useState } from 'react'
import { formattedDate } from '../../utils/formattedDate';
import { USER_PROFILE_PLAN } from '../../constants/common';

const EditSlider = ({ profileData, LazyImage }) => {

  const userPlan = USER_PROFILE_PLAN;

  return (
    <div className='founder-basic-info'>
      <div className='founder-edit-section'>
        <div className='founder-profile-image'>
          <LazyImage
            src={profileData?.profileImg}
            alt="founder"
          />
        </div>
      </div>
      <div className='founder-position'>
        <div className='founder-name'>{profileData?.name}</div>
        {profileData?.type === 1 ? (
          <div className="founder-type">Founder</div>
        )
          : profileData?.type === 2 ? (
            <div className='angel-type'>Angel</div>
          ) : profileData?.type === 3 ? (
            <div className='vc-type'>VC</div>
          ) : (
            <div className='accelerators-type'>Accelerator</div>
          )
        }

        {profileData?.type === 1 ? (
          profileData?.status === 3 ? (
            <div className="founder-suspended-status">Suspended</div>
          ) : profileData?.step === 0 ? (
            <div className="founder-status">Active</div>
          ) : (
            <div className="founder-nc-status">Not Completed</div>
          )
        ) : profileData?.status === 3 ? (
          <div className="user-suspended-status">Suspended</div>
        ) : profileData?.step === 0 ? (
          <div className="user-status">
            Active{" "}
            {profileData?.priceId
              ? `(${userPlan?.find(plan => plan?.key === profileData?.priceId)?.value || profileData?.priceId})`
              : ""}
          </div>
        ) : (
          <div className="user-nc-status">
            Not Completed{" "}
            {profileData?.priceId
              ? `(${userPlan?.find(plan => plan?.key === profileData?.priceId)?.value || profileData?.priceId})`
              : ""}
          </div>
        )}

      </div>
      <div className='founder-date'>Registered on {formattedDate(profileData?.createdAt)}</div>
    </div>
  );

}

export default EditSlider;
